import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { useMediaQuery } from "@mui/material";
import { Colors } from "../helpers/Colors";
import dyootiLogo from "../assets/images/logo/dyooti.svg";
import { display } from "@mui/system";
import { fontSize } from "../helpers/fontSize";
import { font } from "../helpers/font";
import { useNavigate } from "react-router-dom";
import Time from "./Time";
import axios from "axios";
import { format, weeksToDays } from "date-fns";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { Icon_useStyles } from "../useStyles/Icon_useStyles";
import Sidebar from "./Sidebar";
import cabinsLogo from "../assets/images/logo/Cabins.png";

const useStyles = makeStyles({
  Navbar: {
    position: "relative",
    top: 0,
    color: Colors.secondary,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 20px",
    backgroundColor: Colors.white,
    // boxShadow: `${Colors.jerry} 3px 5px`
  },
  leftCon: {
    display: "flex",
    alignItems: "center",
    "& .ProductName": {
      padding: "10px 0px",
      // fontSize: fontSize.ProductName,
      // fontFamily: font.supreme,
      // fontWeight: 500,
      cursor: "pointer",
      "& img": {
        width: "100%",
        height: "20px",
      },
    },
  },
  rightCon: {
    display: "flex",
    alignItems: "center",
    fontSize: fontSize.pageNav,
    fontWeight: 700,

    "& .docs": {
      padding: "0px 10px",
      cursor: "pointer",
      "&:hover": {
        color: Colors.primary,
      },
    },
    "& #time": {
      padding: "0px 10px 0px 0px",
      color: Colors.jerry,
    },
    "& #last": {
      padding: "0px 10px 0px 10px",
    },
    "& #logout": {
      cursor: "pointer",
      padding: "0px 10px 0px 10px",
      "&:hover": {
        color: Colors.error,
      },
    },
    "& #name": {
      padding: "0px 0px 0px 0px",
    },
  },
  UserProfile: {
    backgroundColor: Colors.primaryLight,
    margin: "0px 10px",
    padding: "5px 10px 5px 10px",
    borderRadius: "10px",
    cursor: "pointer",
    "@media only screen and (max-Width:430px)": {
      margin: "0px 8px",
    },
    "@media only screen and (min-Width:1200px)": {
      // margin: "0px 15px",
      "&:hover .dropdownCon": {
        display: "block",
      },
    },
    "& .dropdownCon": {
      zIndex: 3,
      padding: "20px 0 0 0",
      display: "none",
      position: "absolute",
      top: 44,
      right: 89,
      backgroundColor: "transparent",
      "& .dropdown": {
        display: "flex",

        padding: "3px",
        zIndex: 5,
        //  absolute top-16 right-20 bg-white shadow-sm rounded-md
        transform: "scale(1)",
        borderRadius: "10px",
        backgroundColor: Colors.white,
        boxShadow: `0px 2px 5px ${Colors.primary}`,
        "& .pageNav": {
          padding: "5px 20px 5px 20px",
          cursor: "pointer",
          "&:hover": {
            color: Colors.primary,
          },
        },
      },
    },
  },
  MenuIcon: {
    display: "none",
    "@media only screen and (max-Width: 1200px)": {
      display: "block",
    },
  },
  //  `absolute top-0 right-0 bg-neutral-800 transition-all transform ease-in-out duration-300`
  // : `absolute top-0 -right-full bg-neutral-800 transition-all transform ease-in-out duration-300`
  ShowSidebar: {
    zIndex: 9,
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: Colors.secondaryBgOpacity,
    transition: "all 300ms ease-in-out 300ms",
    transform: "all",
  },
  //  `absolute top-0 right-0 bg-secondaryBgOpacity transform transition-all transform ease-in-out duration-700`
  // : `hidden absolute top-0 -right-full transition-all transform ease-in-out duration-500`

  HideSidebar: {
    // absolute top-0 -right-full transition-all transform ease-in-out duration-500
    display: "none",
    position: "absolute",
    top: 0,
    right: -300,
  },

  //   `absolute top-0 right-0 h-screen w-screen bg-secondaryBgOpacity  transform transition-all transform ease-in-out duration-1000`
  // : `hidden`
  ShowCover: {
    zIndex: 7,
    position: "absolute",
    top: 0,
    right: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: Colors.secondaryBgOpacity,

    transition: "all 300ms ease-in-out 300ms",
    transform: "all",
  },
  HideCover: {},
});

const Navbar = ({
  token,
  user,
  isSuperAdmin,
  showSidebar,
  setShowSidebar,
  onLogoutClick,
}) => {
  const classes = useStyles();
  const Icon_Classes = Icon_useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const sidebar = useSelector((state) => state.sidebar.value);

  const onLogoClick = () => {
    setShowSidebar(false);
    navigate("/");
  };
  const onBookingFormClick = () => {
    setShowSidebar(false);
    navigate("/reservation");
  };
  const onAllReservationsClick = () => {
    setShowSidebar(false);
    navigate("/allReservations");
  };
  const onAddCabinClick = () => {
    setShowSidebar(false);
    navigate("/addCabin");
  };
  const onMyCabinsClick = () => {
    setShowSidebar(false);
    navigate("/myCabins");
  };
  const onMyReservationsClick = () => {
    setShowSidebar(false);
    navigate("/myReservations");
  };
  const onUnderMaintenanceClick = () => {
    setShowSidebar(false);
    navigate("/underMaintenance");
  };

  // const onLogoutClick = () => {
  //   axios
  //     .get(`/api/auth/logout`)
  //     .then((res) => {
  //       toast("Logout");
  //     })
  //     .catch((err) => {
  //       toast("Logout Error", err);
  //       console.log(err);
  //     });

  //   // window.open(`http://localhost:5000/api/get/auth/logout`, "_self");
  //   // toast("Logout");
  // };

  // const onSigninClick = () => {
  //   // window.open(`${process.env.LOCAL_API_URL}/auth/google/callback`, "_self");
  //   window.open(`http://localhost:5000/api/auth/google/callback`, "_self");
  //   // axios.get("/api/get/auth/google").then((res) => {
  //   //   if (res) {
  //   //     return console.log("Good");
  //   //   } else return console.log("Bad");
  //   // });
  // };

  // console.log(format("2022-07-27T07:08:53.549+00:00", "dd-MM-yyyy"));
  // console.log(format("2022-07-27T07:08:53.549+00:00", "HH:mm"));
  return (
    <main className={`${classes.Navbar} shadow-md relative`}>
      {/* <Toaster /> */}
      <section className={classes.leftCon}>
        {/* <img src={dyootiLogo} width={130} height={50} /> */}
        {/* <div>'s </div> */}
        <div className="ProductName" onClick={onLogoClick}>
          <img src={cabinsLogo} />
          {/* {window.location.pathname === "/reservation" ? (
            <span className="text-2xl text-primary"> - Make a reservation</span>
          ) : null}
          {window.location.pathname === "/addEmployee" ? (
            <span className="text-2xl text-primary"> - Add an Employee</span>
          ) : null} */}
        </div>
      </section>
      <section>
        {/* {token ? (
          <div className="pageNav" id="last" onClick={onLogoutClick}>
            LOGOUT
          </div>
        ) : null} */}
      </section>
      {/* MenuBar */}
      <section className={classes.rightCon}>
        <div className="pageNav " id="time">
          <Time />
        </div>
        {user && (
          <div className="docs hidden xl:block" onClick={onBookingFormClick}>
            BOOKING FORM
          </div>
        )}
        {isSuperAdmin && (
          <>
            <div
              className="docs  hidden xl:block"
              onClick={onAllReservationsClick}
            >
              ALL RESERVATIONS
            </div>
            <div className="docs  hidden xl:block" onClick={onAddCabinClick}>
              ADD A CABIN
            </div>
            <div className="docs  hidden xl:block" onClick={onMyCabinsClick}>
              MY CABINS
            </div>
          </>
        )}
        {user && (
          <div
            className="docs  hidden xl:block"
            //  id="last"
            onClick={onMyReservationsClick}
          >
            MY RESERVATIONS
          </div>
        )}
        {user ? (
          <section
            className={`${classes.UserProfile}  flex items-center justify-center`}
          >
            <div
              className="pageNav relative mr-2"
              id="name"
              // onClick={onSigninClick}
            >
              {user.name}
            </div>
            <img
              src={user.picture}
              width={30}
              height={30}
              className="rounded-full"
            />
            {/* <div>{user.email}</div> */}

            <main className="dropdownCon">
              <section className="dropdown">
                <div className="pageNav" onClick={onUnderMaintenanceClick}>
                  ABOUT
                </div>
                <div className="pageNav" onClick={onUnderMaintenanceClick}>
                  FAQ
                </div>
                <div className="pageNav" onClick={onUnderMaintenanceClick}>
                  TEAM
                </div>
              </section>
            </main>
          </section>
        ) : null}
        <section
          className={classes.MenuIcon}
          onClick={() => setShowSidebar(!showSidebar)}
        >
          <main className={Icon_Classes.Icon}>
            <div className="iconCon">
              <HiOutlineMenuAlt3 className="icon" id="menu" />
            </div>
          </main>
        </section>
        <main
          style={{ zIndex: 7 }}
          className={
            showSidebar ? classes.ShowCover : classes.HideCover
            //   `absolute top-0 right-0 h-screen w-screen bg-secondaryBgOpacity  transform transition-all transform ease-in-out duration-1000`
            // : `hidden`
          }
        >
          <section
            style={{ zIndex: 7 }}
            className={showSidebar ? classes.ShowSidebar : classes.HideSidebar}

            //   `absolute top-0 right-0 bg-secondaryBgOpacity transform transition-all transform ease-in-out duration-700`
            // : `hidden absolute top-0 -right-full transition-all transform ease-in-out duration-500`
          >
            <Sidebar
              token={token}
              user={user}
              isSuperAdmin={isSuperAdmin}
              onLogoutClick={onLogoutClick}
              showSidebar={showSidebar}
              setShowSidebar={setShowSidebar}
              onLogoClick={onLogoClick}
              onBookingFormClick={onBookingFormClick}
              onAllReservationsClick={onAllReservationsClick}
              onAddCabinClick={onAddCabinClick}
              onMyCabinsClick={onMyCabinsClick}
              onMyReservationsClick={onMyReservationsClick}
              onUnderMaintenanceClick={onUnderMaintenanceClick}
            />
          </section>
        </main>
        {user ? (
          <div
            className="docs hidden xl:block"
            id="logout"
            onClick={onLogoutClick}
          >
            LOGOUT
          </div>
        ) : null}
      </section>
    </main>
  );
};

export default Navbar;
